import { Constants } from '../../../../../constants';
import { DateTypes, formatDate } from '../../../../../utils/timeUtils';
import { parseStringModifiers } from '../../../../../utils/utils';
import { GalleryPages, GalleryProps } from '../../../constants';
import {
  getReasonTitle,
  getSideloadExplanation,
} from '../../../features/products/controllers/variables';
import { OverviewLayout } from '../components/OverviewLayout';
import { parcelKeys } from './variables';

const Overview = ({ parcel, parcelDetails, isLoading }) => {
  const {
    photos,
    [parcelKeys.id]: id,
    [parcelKeys.alias]: alias,
    [parcelKeys.status]: status,
    riskType,
    sender_brand_name: reason,
    activity,
    [parcelKeys.sideloadDate]: catchDate,
    rest_quantity: totalItems,
    situation,
    detection,
  } = parcelDetails ?? parcel ?? {};

  const {
    psButtons: actions,
    psCode: situationcode,
    psConfirmButtons: confirmationButtons,
    psID: situationId,
    psInstructions: instructions,
    psStyle: styleStatus,
    psTitle: situationTitle,
    psAlerts: situationAlerts,
  } = situation ?? {};

  const {
    pdConfidence: confidence,
    pdMatchText: matchText,
    pdMatchType: matchType,
    pdOCR: cameraRead,
    pdSenderFull: databseMatch,
  } = detection ?? {};

  const details = [
    {
      title: 'Camera Read: ',
      text: ` ${cameraRead ?? Constants.fallback}`,
    },
    {
      title: 'Database Match: ',
      text: ` ${databseMatch ?? Constants.fallback}`,
    },
    {
      title: 'Match Type: ',
      text: ` ${matchType ?? Constants.fallback}`,
    },
    {
      title: 'Matched Text: ',
      text: ` ${matchText ?? Constants.fallback}`,
    },
    {
      title: 'Catch date: ',
      text: ` ${
        catchDate
          ? `${formatDate(catchDate, DateTypes.ddmmyy)} - ${formatDate(
              catchDate,
              DateTypes.time12
            )}`
          : Constants.fallback
      }`,
    },
    {
      title: 'Total items: ',
      text: ` ${totalItems ?? Constants.fallback}`,
    },
  ];

  const description = {
    title: parseStringModifiers(
      'FACILITATOR VIEW\n' + (situationTitle ?? Constants.fallback)
    ),
    text: parseStringModifiers(instructions ?? Constants.fallback),
    status: styleStatus,
    alerts: situationAlerts,
  };

  const riskAnalysisProps = {
    reason: {
      description:
        getSideloadExplanation(reason, riskType) ?? Constants.fallback,
      riskPotential: {
        value: confidence,
        display: `${confidence}%`,
        fill: '#0c57bf',
      },
      title: getReasonTitle(reason),
    },
    riskType,
    noShadow: true,
    size: '_M',
  };

  const recentActivityProps = {
    noShadow: true,
    activity: (activity ?? []).map(
      ({ createdAt, plContent, plType, usDisplayName }) => ({
        date: `${formatDate(createdAt, DateTypes.ddmmyyyy)}, ${formatDate(
          createdAt,
          DateTypes.time12
        )}`,
        text: parseStringModifiers(plContent ?? Constants.fallback),
      })
    ),
  };

  return (
    <OverviewLayout
      detailsProps={{ details, status }}
      previewGalleryProps={{
        galleryProps: GalleryProps[GalleryPages.parcels],
        images: photos?.map(photo => photo.ppThumb),
        id,
        galleryTitle: `Parcel ${alias}`,
      }}
      descriptionProps={{ ...description }}
      riskAnalysisProps={riskAnalysisProps}
      recentActivityProps={recentActivityProps}
      isLoading={isLoading}
    />
  );
};

export default Overview;
